module.exports = __webpack_public_path__ + "img/logo.10c48037.png";